import React, { FC, useEffect, useState } from "react";

interface OwnProps {
  
    phone: String;
}
type Props = OwnProps;
const GlobalPhoneFormat: FC<Props> = ({
    phone
}) => {
  const [formattedPhone, setFormattedPhone] = useState(phone);

  useEffect(() => {
    const digits = phone.replace(/\D/g, '');

    if (digits.length >= 10) {
      const part1 = digits.slice(0, 3);
      const part2 = digits.slice(3, 6);
      const part3 = digits.slice(6, 10);
      const remaining = digits.slice(10); // any extra digits beyond the first 10

      const formatted = `(${part1}) ${part2}-${part3}${remaining ? ` ${remaining}` : ''}`;
      setFormattedPhone(formatted);
    } else {
      setFormattedPhone(digits); // fallback to digits-only
    }
  }, [phone]);

  return <>{formattedPhone}</>;
};

export default GlobalPhoneFormat;
